import {Component, input, ChangeDetectionStrategy} from '@angular/core';

@Component({
    selector: 'app-overview-navigation-tabs',
    templateUrl: './overview-navigation-tabs.component.html',
    styleUrls: ['./overview-navigation-tabs.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class OverviewNavigationTabsComponent {
  items = input<NavigationItem[]>();
  mobile = input<boolean>();
}

export interface NavigationItem {
  routerLink: string;
  icon: string;
  text: string;
}
